<template>
    <div class="container mb-50 chooseMultiligne">
      <p class="c-orange text-bold text-xl lg:text-2xl leading-24 lg:leading-28 mb-10 lg:mb-20">Les avantages exclusifs</p>
      <h2 class="title-default mb-20 lg:mb-40">Open Multilignes, ajouter des lignes et cumulez les remises</h2>

      <div class="dflex items-center mb-25">
        <p class="font-bold text-sm lg:text-lg leading-22 lg:leading-24 c-black2white">Ajoutez <span class="c-orange">jusqu'à 4 forfaits</span> mobile et profitez des remises Open Multilignes</p>
        <div class="form-toggle form-toggle--big ml-auto md:ml-15">
          <input @click="chooseMultiligne" class="form-toggle-input" id="addMultilines" type="checkbox" name="addMultilines" value="1" role="switch">
          <label class="form-toggle-label" for="addMultilines">
              <span class="no">Non</span>
              <span class="check"></span>
              <span class="yes">Oui</span>
          </label>
        </div>
      </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { onMounted, nextTick } from 'vue';


const error = ref(null);
const isLoading = ref(true);

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  multiligne: Number,
  tag: Object
});

const emit = defineEmits(['loadMultiligne1','disableMultiligne']);

function chooseMultiligne(event) {

  const isChecked = event.target.checked;
  //console.log('chooseMultiligne:'+isChecked);
  if (isChecked) {
    emit('loadMultiligne1');
  } else {
    emit('disableMultiligne');
  }

}


onMounted(async () => {
  try {

    const chooseMultiligne = document.querySelector('.chooseMultiligne')
    if (chooseMultiligne) {
      chooseMultiligne.scrollIntoView({
        behavior: 'smooth',  // défilement fluide
        block: 'start'       // aligne en haut de la fenêtre
      })
    }
    if (props.parcours.multilignes.multiligne1.forfait != 0) {
      //console.log('Multiligne Existe');
      const bouton = document.getElementById('addMultilines');
      if (bouton) {
        console.log('CHECK MULTILIGNE');
        bouton.click();
      }
    }

  } catch (e) {
    error.value = e.message;
  } finally {
    isLoading.value = false;
  }
});
</script>
